import { Injectable, Inject } from "@angular/core";
import { AppConfig } from "src/environments/appconfig";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Tipocambiomast, TipocambiomastPk } from "../dominio/Tipocambiomast";
import { UHttpsClient } from "../../../../seguridad/seguridad/uhttpsClient";

@Injectable()
export class TipocambiomastServicio {

    private url = `${this.config.getEnv('proxy')}spring/core/tipocambiomast/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public obtenerTipoCambio(pk: TipocambiomastPk): Promise<Tipocambiomast> {
        return this.http.post(`${this.url}obtenerTipoCambio`, pk,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as Tipocambiomast;
            })
            .catch(error => new Tipocambiomast());
    }
}

